import { Button } from '@simplywallst/ui-core/next';

import PlusSolid from '@simplywallst/ui-core/icons/PlusSolid';
import type { ComponentProps } from 'react';
import { useCreateNarrativeLink } from '@/pages/Narrative/hooks/useCreateNarrativeLink';

type Props = {
  companyId: string;
  variant?: ComponentProps<typeof Button>['variant'];
  size?: ComponentProps<typeof Button>['size'];
};

export const CompanyNarrativesCreateButton = ({
  companyId,
  variant = 'secondary',
  size = 'medium',
}: Props) => {
  const { href, onClick } = useCreateNarrativeLink({
    companyId,
  });

  if (!href) return null;

  return (
    <Button variant={variant} size={size} onClick={onClick} href={href}>
      <PlusSolid /> Create Narrative
    </Button>
  );
};
